import * as React from 'react';

import css from './toggle.css';

import classify from 'src/utils/classify';

/**
 * Note:
 * Do not wrap Toggle in a label. For simplicity's sake, Toggle uses an
 * internal label tag to handle click delegation to the hidden input, and
 * nesting labels is a bad idea.
 */

type Props = {
  className?: string;
  toggleContainer?: string;
  toggleClassName?: string;
  children?: React.ReactNode;
  checked?: unknown;
  onChange?: (arg1: React.ChangeEvent<HTMLInputElement>) => unknown;
  disabled?: unknown;
  qaId?: string;
};

export const Toggle = ({
  className,
  toggleContainer,
  toggleClassName,
  children,
  qaId,
  disabled,
  ...props
}: Props) => (
  <label
    className={classify(toggleContainer || css.container, className)}
    data-qa-id={`${qaId ? qaId + '-' : ''}toggle`}
  >
    {/* @ts-expect-error - TS2322 - Type '{ "data-qa-id": string; checked?: unknown; onChange?: ((arg1: ChangeEvent<HTMLInputElement>) => unknown) | undefined; type: "checkbox"; }' is not assignable to type 'DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>'. */}
    <input type="checkbox" {...props} data-qa-id="toggle-input" />
    <div
      className={classify(toggleClassName || css.toggle, {
        [css.disabled]: disabled,
      })}
    >
      {children}
    </div>
  </label>
);

export default Toggle;
